const gridWrapper = document.querySelector('#product-grid');



(() => {
  const layoutBtns = document.querySelectorAll('.layout-btns-container span');
  const productGrid = document.getElementById('product-grid');
  if (!layoutBtns.length || !productGrid) return;

  layoutBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const desktopClass = btn.dataset.desktop;
      const mobileClass = btn.dataset.mobile;
      const isMobile = window.innerWidth <= 749;

      // 🧹 Remove only classes starting with "grid--"
      const toRemove = [...productGrid.classList].filter(cls => cls.startsWith('grid--'));
      productGrid.classList.remove(...toRemove);

      // 🎯 Add correct layout class
      productGrid.classList.add(isMobile ? mobileClass : desktopClass);

      // ✅ Optional: mark active button
      layoutBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // 🔄 Reapply correct layout when resizing (if active button exists)
  window.addEventListener('resize', () => {
    const activeBtn = document.querySelector('.layout-btns-container span.active');
    if (!activeBtn) return;

    const desktopClass = activeBtn.dataset.desktop;
    const mobileClass = activeBtn.dataset.mobile;
    const isMobile = window.innerWidth <= 749;

    const toRemove = [...productGrid.classList].filter(cls => cls.startsWith('grid--'));
    productGrid.classList.remove(...toRemove);

    productGrid.classList.add(isMobile ? mobileClass : desktopClass);
  });
})();

if (typeof Ajaxinate !== 'undefined' && gridWrapper) {
  const endlessScroll = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    loadingText: 'Loading...',
    method: "scroll",
    callback: function() {
      initCardSwatches();
      initAtcButtons();
      handleProductCardMouseLeave();
    }
  });
}
